import { render, staticRenderFns } from "./VideoPanel.vue?vue&type=template&id=1bc4606c&scoped=true&"
import script from "./VideoPanel.vue?vue&type=script&lang=js&"
export * from "./VideoPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoPanel.vue?vue&type=style&index=0&id=1bc4606c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4606c",
  null
  
)

export default component.exports